export enum TipoOrigemEnum {

  Nacional = 'NACIONAL',
  Estrangeira = 'ESTRANGEIRA',

}
